// extracted by mini-css-extract-plugin
module.exports = {"periodName":"SelectedDateRangeHeading_periodName__2z1MF","dateRange":"SelectedDateRangeHeading_dateRange__3DSgZ"};